import { Component, OnInit, ViewChild } from '@angular/core';
import { UbiDialogComponent } from 'uber-ui';
import { DialogService } from './dialog.service';

@Component({
  selector: 'artemis-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit {

  @ViewChild('dialog', {static: true}) dialog: UbiDialogComponent;

  data: any = {};

  constructor(
    private dialogService: DialogService
  ) { }

  getInstance() {
    return this;
  }

  ngOnInit() {
    this.dialogService.setDialog(this.getInstance.bind(this));
  }

  setData(data: { title: string, message: string, type: 'alert' | 'confirm' }) {
    this.data = data;
  }

  submit() {
    this.dialog.submit();
  }

  close() {
    this.dialog.close();
  }
}
